import { render, staticRenderFns } from "./AppModals.vue?vue&type=template&id=5b109e9d&scoped=true&"
import script from "./AppModals.vue?vue&type=script&lang=ts&"
export * from "./AppModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b109e9d",
  null
  
)

export default component.exports